import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
import { extractErrorMessage } from "../../../utils/errorHandler";
const userApi = factory.get("user");
const initialState = {
  user: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 25,
      search: "",
    },
    dialog: false,
  },
  manageUser: {
    form: {
      id: "",
      name: "",
      email: "",
      password: "",
      mobile: "",
    },
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setUser: (state, action) => {
      state.user.data = action.payload.data;
      state.user.total = action.payload.total;
    },
    setFilters: (state, { payload }) => {
      state.user.filters = {
        ...state.user.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.user.filters = initialState.user.filters;
    },
    setDialog: (state, { payload }) => {
      if (payload) {
        state.manageUser.form.id = payload.id;
        state.manageUser.form.name = payload.name;
        state.manageUser.form.email = payload.email;
        state.manageUser.form.mobile = payload.mobile;
      } else {
        state.manageUser.form = initialState.manageUser.form;
      }
      state.manageUser.dialog = !state.manageUser.dialog;
    },
    resetForm: (state, action) => {
      state.manageUser.form = initialState.manageUser.form;
    },
  },
});

export const {
  setLoading,
  setUser,
  setFilters,
  resetFilters,
  resetForm,
  setDialog,
} = userSlice.actions;

export default userSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().user.user.filters;
    dispatch(setLoading("user"));
    const res = await userApi.index(filters);
    dispatch(setUser(res.data));
    dispatch(setLoading("user"));
  } catch (err) {
    dispatch(setLoading("user"));
    console.log(err);
  }
};

const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("manageUser"));
    await userApi.create(data);
    dispatch(setLoading("manageUser"));
    dispatch(
      showNotification({
        type: "success",
        message: "User Created successfully",
      })
    );

    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("manageUser"));
    dispatch(
      showNotification({
        type: "error",
        message: extractErrorMessage(err),
      })
    );
    console.log(err);
  }
};

const update = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading("manageUser"));
    await userApi.update(id, data);
    dispatch(setLoading("manageUser"));
    dispatch(
      showNotification({
        type: "success",
        message: "User updated successfully",
      })
    );

    dispatch(setDialog());
    dispatch(resetForm());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("manageUser"));
    dispatch(
      showNotification({
        type: "error",
        message: extractErrorMessage(err),
      })
    );
    console.log(err);
  }
};

const deleteUser = (id) => async (dispatch, getState) => {
  try {
    await userApi.delete(id);
    dispatch(
      showNotification({
        type: "success",
        message: "Updated status successfully",
      })
    );
    dispatch(index());
  } catch (err) {
    dispatch(
      showNotification({
        type: "error",
        message: extractErrorMessage(err),
      })
    );
    console.log(err);
  }
};
export const User = {
  index,
  create,
  update,
  deleteUser,
};
